import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import Sucursales from './Sucursales';

class SucursalesSelector extends Component {
    constructor(props) {
        super(props);

        this.filterList = this.filterList.bind(this);
        this.checkItem = this.checkItem.bind(this);
        this.checkAllItems = this.checkAllItems.bind(this);
        this.unCheckAllItems = this.unCheckAllItems.bind(this);
        this.saveBranches = this.saveBranches.bind(this);
        this.cancelBranches = this.cancelBranches.bind(this);
        this.cleanInput = this.cleanInput.bind(this);
        this.changeMassive = this.changeMassive.bind(this);

        this.state = {
            inputValue: undefined,
            branchesList: undefined,
            filteredList: undefined,
            modalOpen: false
        };
    }

    cleanInput() {
        this.setState({
            inputValue: "",
            filteredList: this.state.branchesList
        });
    }

    filterList(event) {
        this.setState({ inputValue: event.target.value });

        let updatedList = JSON.parse(JSON.stringify(this.state.branchesList));
        updatedList = updatedList.filter(function (item) {
            const re1 = item.Descripcion.toUpperCase().search(event.target.value.toUpperCase()) !== -1;
            const re2 = item.VALOR_X.toString().search(event.target.value) !== -1;

            return re1 || re2
        });

        this.setState({ filteredList: updatedList });
    }

    checkItem(branchId) {
        let updatedList = JSON.parse(JSON.stringify(this.state.branchesList));
        let edicion = this.props.edicion;
        let updatedFilteredList = JSON.parse(JSON.stringify(this.state.filteredList));

        updatedList.forEach(function (item) {
            if (item.Id == branchId) {
                item.Checked == true ? item.Checked = false : item.Checked = true;
                if (edicion) {
                    item.Cambio = !item.Cambio;
                }
            }
        })

        updatedFilteredList.forEach(function (item2) {
            if (item2.Id == branchId) {
                item2.Checked == true ? item2.Checked = false : item2.Checked = true;
            }
        })

        this.setState({
            filteredList: updatedFilteredList,
            branchesList: updatedList
        });
    }

    checkAllItems() {
        let updatedList = JSON.parse(JSON.stringify(this.state.branchesList));
        updatedList = this.changeMassive(updatedList, true);

        this.setState({
            inputValue: "",
            filteredList: updatedList,
            branchesList: updatedList
        });
    }

    unCheckAllItems() {
        let updatedList = JSON.parse(JSON.stringify(this.state.branchesList));
        updatedList = this.changeMassive(updatedList, false);

        this.setState({
            inputValue: "",
            filteredList: updatedList,
            branchesList: updatedList
        });
    }

    changeMassive(list, check) {
        let edicion = this.props.edicion;
        list.forEach(function (item) {
            if (item.Checked != check) {
                item.Checked = check;
                if (edicion) {
                    item.Cambio = !item.Cambio;
                };
            }
        })
        return list;
    }

    saveBranches() {
        this.props.saveSelectedBranches(this.state.branchesList, 'sucursal');

        this.setState({
            inputValue: undefined,
            filteredList: undefined,
            branchesList: undefined,
            modalOpen: false
        });

        $('#SucursalesSelector').modal('hide');
    }

    cancelBranches() {
        this.props.cancelSelectedBranches('sucursal');

        this.setState({
            inputValue: undefined,
            filteredList: undefined,
            branchesList: undefined,
            modalOpen: false
        });

        $('#SucursalesSelector').modal('hide');
    }

    componentDidMount() {
        this.setState({
            filteredList: this.props.data,
            branchesList: this.props.data
        });
    }

    componentWillReceiveProps(nextProps) {
        //if (this.state.modalOpen === false) {
            this.setState({
                inputValue: "",
                filteredList: nextProps.data,
                branchesList: nextProps.data,
                modalOpen: true
            });
        //}
    }

    render() {
        let cleanInputSpan = null;

        if (this.state.inputValue != "" && this.state.inputValue != undefined) {
            cleanInputSpan = <div className="buttons-x-top-right"><span id="clearInput" className="btn-x-top-right" onClick={this.cleanInput}><i className="ti-close"></i></span></div>;
        }
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="btn-x-top-right-container2">
                                <span className="ti-search input-icon-span"></span>
                                <input type="text" placeholder="Buscar por número o nombre" className="form-control default-input input-with-icon" value={this.state.inputValue} onChange={this.filterList} />
                                {cleanInputSpan}
                            </div>
                        </div>
                    </div>
                    <div className="row top-separator-xs">
                        <div className="col-xs-3">
                            <label className="label-3">Seleccionar</label>
                        </div>
                        <div className="col-xs-2">
                            <GenericSimpleButton text="Todas" buttonType="button" buttonClass="btn-link btn-link-secondary" onClick={this.checkAllItems} />
                        </div>
                        <div className="col-xs-2">
                            <GenericSimpleButton text="Ninguna" buttonType="button" buttonClass="btn-link btn-link-secondary" onClick={this.unCheckAllItems} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <Sucursales data={this.state.filteredList} checkItem={this.checkItem} />
                        </div>
                    </div>
                    <div className="row top-separator-xs selector-footer">
                        <div className="col-xs-6">
                            <GenericSimpleButton text="Aceptar" buttonType="button" buttonClass="btn btn-cta" onClick={this.saveBranches} />
                        </div>
                        <div className="col-xs-6">
                            <GenericSimpleButton text="Cancelar" buttonType="button" buttonClass="btn btn-secondary item-pull-right" onClick={this.cancelBranches} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default SucursalesSelector;